import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-base-icon',
  template: `
    <svg
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [attr.fill]="fill()"
      [style.color]="color()"
      [class]="iconClass()"
      xmlns="http://www.w3.org/2000/svg">
      <ng-content></ng-content>
    </svg>
  `,
})
export class BaseIconComponent {
  width = input<string>('1.25rem');
  height = input<string>('1.25rem');
  viewBox = input<string>('0 0 20 20');
  fill = input<string>('none');
  color = input<string>('currentColor');
  iconClass = input<string>('');
}
